import React from 'react'
import { connect } from 'react-redux'
import BackButton  from '../Button/Button'
import {
    Box, Typography, Grid, Paper, Avatar, Chip,
    Divider, List, ListItem, ListItemIcon, ListItemText
} from '@material-ui/core'
import {
    MapPin, Star, Users, Bed, Bath, Home,
    ShieldCheck, Clock, CheckCircle2, XCircle
} from 'lucide-react'


const ListingPage = props => {
    const { viewedListing } = props.homesDispatch
    const {
        name, stars, reviewDetailsInterface, p3SummaryAddress, bedroomLabel,
        bedLabel, bathroomLabel, numberOfGuests,primaryHost, sectionedDescription, photos,
        guestControls, localizedCheckInTimeWindow, localizedCheckOutTime, isHostedBySuperhost
    } = viewedListing
    return (
        <Box sx={{ maxWidth: 1100, margin: 'auto', p: 3, bgcolor: '#f9f9f9' }}>
            <BackButton/>
            <Box sx={{ mb: 4 }}>
                <Typography variant="h4" fontWeight="bold" gutterBottom>
                    {name}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Star size={18} fill="#FF385C" color="#FF385C" />
                        <Typography variant="subtitle1" sx={{ ml: 0.5, fontWeight: 'bold' }}>
                            {stars} · {reviewDetailsInterface.reviewCount} reviews
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
                        <MapPin size={18} />
                        <Typography variant="subtitle1" sx={{ ml: 0.5 }}>
                            {p3SummaryAddress}
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <Grid container spacing={4}>
                <Grid item xs={12} md={8}>
                    <Box sx={{ mb: 3 }}>
                        <img src={ photos[0].large } className='card-image'/>
                        <Typography variant="h5" fontWeight="semibold">
                            Entire rental unit hosted by {primaryHost.firstName}
                        </Typography>
                        <Typography color="text.secondary">
                            {numberOfGuests} guests · {bedroomLabel} · {bedLabel} · {bathroomLabel}
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 3 }} />
                    {isHostedBySuperhost && (
                        <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                            <ShieldCheck size={28} />
                            <Box>
                                <Typography fontWeight="bold">{primaryHost.firstName} is a Superhost</Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Superhosts are experienced, highly rated hosts who are committed to providing great stays for guests.
                                </Typography>
                            </Box>
                        </Box>
                    )}
                    <Divider sx={{ my: 3 }} />

                    <Box>
                        <Typography variant="h6" gutterBottom>About this space</Typography>
                        <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
                            {sectionedDescription.description}
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 3 }} />

                    <Typography variant="h6" gutterBottom>House Rules</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon><Clock size={20} /></ListItemIcon>
                                    <ListItemText primary="Check-in" secondary={localizedCheckInTimeWindow} />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><Clock size={20} /></ListItemIcon>
                                    <ListItemText primary="Check-out" secondary={localizedCheckOutTime} />
                                </ListItem>
                            </List>
                        </Grid>
                        <Grid item xs={6}>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon>
                                        {guestControls.allowsPets ? <CheckCircle2 size={20} color="green" /> : <XCircle size={20} color="red" />}
                                    </ListItemIcon>
                                    <ListItemText primary="Pets allowed" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        {guestControls.allowsSmoking ? <CheckCircle2 size={20} color="green" /> : <XCircle size={20} color="red" />}
                                    </ListItemIcon>
                                    <ListItemText primary="Smoking allowed" />
                                </ListItem>
                            </List>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}

const mapStateToProps = () => (
    dispatch => ({
        homesDispatch: dispatch.homes
    })
);


export default connect(mapStateToProps)(ListingPage);
